import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TTicketComment } from '../types/ticket-comment.type';

export const UpdateTicketCommentValidationSchema = z.object({
  commentId: z.string({ message: 'Comment ID is required' }).min(1),
  content: z.string().optional(),
  hasMention: z.boolean().optional(),
});
export type TUpdateTicketCommentValidation = z.infer<typeof UpdateTicketCommentValidationSchema>;
export type TUpdateTicketCommentPayload = TUpdateTicketCommentValidation;
export type TUpdateTicketCommentResponse = ApiResponse<TTicketComment>;

export const updateTicketComment = (payload: TUpdateTicketCommentPayload): Promise<TUpdateTicketCommentResponse> => {
  const url = `/comment/${payload.commentId}`;

  const payloadData = {
    content: payload?.content,
    hasMention: payload?.hasMention,
  };

  return axiosInstance.patch(url, payloadData);
};

/**
 * Use Update Ticket Comment React-Query Hook
 */
type UseUpdateTicketCommentMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof updateTicketComment, AxiosErrorCustom>;
};

export const useUpdateTicketCommentMutation = ({ mutationConfig }: UseUpdateTicketCommentMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: updateTicketComment,
    ...restConfig,
  });
};
